import { render, staticRenderFns } from "./RedirectDialog.vue?vue&type=template&id=e649d1b8&"
import script from "./RedirectDialog.vue?vue&type=script&lang=js&"
export * from "./RedirectDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports